module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABMElEQVR4Xu2ZsQ0CQQwE12UgBNUQQBOk1AQhTZBQDS/Rhkk+IOCR2BPSyTfEv/e367FfFqHBfzG4fxEABAyeAC0wOAAMQVqAFhg8AVpgcAD4CtACtICRQGbuJV1m6Skibp+OycyDpLOkjfGaXySTpMV7fDvIaoHMfLyZmiJiuxDA+3O/GHKeXbzHPwJ4SlrNBz8jYj1aADtJ19n0MSLuQ7WAw2evGmsG9GrGuRcBOKlV0kBApWo6XiDASa2SBgIqVdPxYhHANsg2mGyDbIPOxOlQYw3BDn3YVyIAO7oiQggoUkjbBgTY0RURQkCRQto2LALYBtkG2Qb5b9CeOp0JrSHYmYem6xBAU3wFxBBQoIhNFiCgKb4CYggoUMQmCxDQFF8BMQQUKGKTBQhoiq+A+AWERn5BgpReUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/menu.png
// module id = F7yA
// module chunks = 22